export const KNOWN_STEP_VERBS = new Set([
    'emit',
    'fetch',
    'filter',
    'persist',
    'group',
    'resolve',
    'flag',
    'for-each',
    'compose',
    'create',
    'present',
    'collect',
    'submit',
    'archive',
    'invoke',
    'open',
    'review',
    'confirm',
    'notify',
    'notify.operator',
    'classify',
    'classify.embed',
    // Added during the TimeBill dogfood (Wave 1c):
    'apply',
    'calculate',
    'render',
]);
//# sourceMappingURL=verbs.js.map